import { useSuspenseQuery } from "@apollo/client/react";

import { GET_LINE_UNIT_MESSAGE } from '../graphql';

interface UseSuspenseGetLineUnitMessageProps {
  messageId?: string;
  skip?: boolean;
}

export const useSuspenseGetLineMessage = ({
  messageId,
  skip,
}: UseSuspenseGetLineUnitMessageProps) => {
  const { data } = useSuspenseQuery(GET_LINE_UNIT_MESSAGE, {
    skip,
    variables: {
      input: {
        messageId: messageId ?? '',
      },
    },
  });

  return {
    data: data?.UnitMessage,
  };
};
